
import React from "react";
import PropTypes from "prop-types";
import { Icon } from "antd";

const EditIcon = (props) => {
  const { handleClick,color="blue",style,loading=false } = props;
  return (
    <>
      <Icon
        type={loading ? "loading" : "edit"}
        theme={loading ? "outlined" : "twoTone"}
        twoToneColor={color}
        style={style}
        onClick={loading ? undefined : handleClick}
      />
    </>
  );
};

EditIcon.propTypes = {
  handleClick: PropTypes.func,
  loading: PropTypes.bool,
};

EditIcon.defaultProps = {
  handleClick: () => {},
  loading: false,
};
export default EditIcon;
